export default {
      id: "arcs_toppost-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#arcs_toppost-usage",
      toString: function () {
        return this.url;
      }
    }